import { render } from "./TableScaleControl.vue?vue&type=template&id=23641242&scoped=true"
import script from "./TableScaleControl.vue?vue&type=script&lang=js"
export * from "./TableScaleControl.vue?vue&type=script&lang=js"

import "./TableScaleControl.vue?vue&type=style&index=0&id=23641242&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23641242"]])

export default __exports__